export default __webpack_public_path__ + "static/media/canvil-cover.f81e63ef.png";